export default [{
  path: '/parcelamento-mei/pert',
  component: {
    name: 'parcelamentoPertMeiBase',
    template: '<router-view />',
    meta: {
      resource: 'parcelamento_pertmei',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'parcelamento_pertmei-view',
    component: () => import('@/app/parcelamentos-mei/parcelamento-pert/ParcelamentoPertView.vue'),
    meta: {
      tipo: 'PERT',
      resource: 'parcelamento_pertmei',
      action: 'read',
      navActiveLink: 'parcelamento_pertmei-view',
      pageTitle: 'PERT',
      breadcrumb: [
        {
          text: 'Parcelamento PERT',
          to: { name: 'parcelamento_pertmei-view' },
          active: true,
        },
      ],
    },
  }],
},
]
